import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig.js';

const pcaInstance = new PublicClientApplication(msalConfig);

export default pcaInstance;
